<template>
  <div class="page-container">
    <div class="page-header">
      <h1 class="page-title">내 정보</h1>
      <p class="page-desc">계정 정보를 확인하고 수정합니다</p>
    </div>
    
    <div class="content-placeholder">
      <v-icon size="80" color="grey-lighten-1">mdi-account-cog-outline</v-icon>
      <p>내 정보 페이지입니다</p>
      <span>계정 정보, 비밀번호 변경 등이 표시됩니다</span>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
